// Toast tipleri
const toastTypes = {
  success: {
    color: 'green' as const,
    icon: 'i-heroicons-check-circle'
  },
  error: {
    color: 'red' as const,
    icon: 'i-heroicons-x-circle'
  },
  warning: {
    color: 'yellow' as const,
    icon: 'i-heroicons-exclamation-triangle'
  },
  info: {
    color: 'blue' as const,
    icon: 'i-heroicons-information-circle'
  }
} as const

type ToastType = keyof typeof toastTypes

const defaultTitles: Record<ToastType, string> = {
  success: 'Başarılı',
  error: 'Hata',
  warning: 'Uyarı',
  info: 'Bilgi'
}

// Varsayılan konfigürasyon
const defaultConfig = {
  timeout: 2000,
  closeButton: {
    icon: 'i-heroicons-x-mark-20-solid',
    color: 'gray' as const,
    variant: 'link',
    padded: false
  }
} as const

export const useCustomToast = () => {
  const toast = useToast()

  // Toast gösterme fonksiyonu
  const show = (message: string, type: ToastType = 'info', title = '', config = {}) => {
    const toastType = toastTypes[type]
    const defaultTitle = defaultTitles[type] || type.charAt(0).toUpperCase() + type.slice(1)
    toast.add({
      title: title || defaultTitle,
      description: message,
      ...toastType,
      ...defaultConfig,
      ...config
    })
  }

  return {
    success: (message: string, title?: string, config = {}) =>
      show(message, 'success', title, config),
    error: (message: string, title?: string, config = {}) =>
      show(message, 'error', title, config),
    warning: (message: string, title?: string, config = {}) =>
      show(message, 'warning', title, config),
    info: (message: string, title?: string, config = {}) =>
      show(message, 'info', title, config)
  }
}
